module.exports = __webpack_public_path__ + "static/img/dos.dd5fa76a.png";